import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const BuyeasyUserPropertiesTranslations = wrapTranslationsSchema({
	name: 'BuyEasyUserPropertiesTranslations',
	title: 'User Properties Translations',
	sanityId: 'buyeasy-userProperties',
	fields: {
		headerTitle: 'Enable Accurate Browsing',
		description: 'Changes you make to these values do not affect your settings in Ariba.',
		saveButton: 'SAVE',
		subheaderTitle: 'Provide these values to filter your view of suppliers.',
		aribaLink: 'Not sure? Find these values in Ariba.',
		aribaLinkValue:
			'https://mytakeda.sharepoint.com/sites/Procurement/SitePages/Ariba-Profile-Setup-and-Instructions.aspx',
		userSearch: 'Search for a user:',
		custom: 'Custom',
		select: 'Select',
		defaultToMyProps: 'Default to my user properties',
		editManually: 'Manually enter or edit user properties:',
		country: 'Country',
		companyCode: 'Company Code',
		purchasingOrganization: 'Purchasing Organization',
		updatedForSelectedUser: 'Values have been updated to match the selected user.',
		countryChanged: 'You have manually changed the country for this user.',
		companyCodeChanged: 'You have manually changed the company code for this user.',
		purchasingOrganizationChanged:
			'You have manually changed the purchasing organization code for this user.',
		note: 'NOTE',
		aribaRequestorRole: 'The Ariba Requester role',
		aribaRequestorGuideLinkTitle: 'user guide',
	},
});
